<template>
  <div class="vx-card p-6 minus-top">
    <div class="flex flex-wrap items-center">
      <div class="vx-row w-full">
          <div class="vx-col" >
            <label >{{$t('exportFile.typesReport')}}</label>
            <v-select style="width: 250px"
              class="text-size"
              :options ="optionalTime"
              v-model="rangeTimeSelected"
              >
              </v-select>
          </div>
          <div class="vx-col selected-topic">
            <label> {{$t('exportFile.topic')}}</label>
            <v-select style="width: 260px"
              class="text-size"
              v-model="valueSelected"
              :options ="optionalTopics"
              multiple
              />
          </div>
          <div class="vx-col selected-topic">
            <label> {{$t('exportFile.source')}}</label>
            <v-select style="width: 260px"
              class="text-size"
              v-model="valueSelectedArticle"
              :options ="optionalArticle"
              multiple
              />
          </div>
          <div class="vx-col  mt-5">
            <date-range-picker
                ref="picker"
                :locale-data="{format: 'dd/mm/yyyy' }"
                :opens="'left'"
                @update="initScreen"
                v-model="dateRange">
              >
              </date-range-picker>
          </div>
          <div class="export-file mt-5">
            <vs-button class="text-size" style="border-radius:20px" @click="exportFile">{{$t('exportFile.exportReport')}}</vs-button>
          </div>
        </div>
    </div>
    </div>
</template>
<script>
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import vSelect from 'vue-select'
import authConfig from '@/../auth_config.json';
export default{
  components:{
    DateRangePicker,
    vSelect
  },
  data(){
    return{
      valueSelected: [],
      valueSelectedArticle:[],
      optionalTopics: [],
      optionalArticle: [
        {label: 'Bài viết Facebook', value: 104},
        {label: 'Bình luận Facebook', value: 105},
        {label: 'Tin tức', value: 101},
        {label: 'Youtube', value: 106},
        {label: 'Forum', value: 111},
        {label: 'Google', value: 113}
      ],
      optionalTime:[
        {label:'Sức khỏe thương hiệu ngày', value:0},
        {label:'Sức khỏe thương hiệu tuần', value:1}
      ],
      dateRange: {
          endDate: new Date(),
          startDate: (() => { let date = new Date ();
            date.setDate(date.getDate() - 6);
            date.setHours(0,0,0);
            return date
        })()
      },
      valueOption:null
    }
  },
  computed:{
    rangeTimeSelected:{
      get(){
        let object = this.optionalTime.find(el => this.valueOption === el.value);
        if(!object) {return {};}
        return{
          label:object.label,
          value:this.valueOption
        }
      },
      set(object){
        this.valueOption = object ? object.value : null;
      }
    }
  },
  methods:{
    getTopics: function(){
      this.$business.post('topic/find-by-conditions', {}).then((response) => {
        this.optionalTopics = response.data.map(el => {
          return {
            label: el.topicName,
            value: el.id
          }
        })
      })
    },

    initScreen(){
      this.getTopics();
      this.updateI18n();
      this.checkboxSource();

    },
    updateI18n: function(){
      this.optionalTime[0].label = this.$t('exportFile.brandHealthByDay')
      this.optionalTime[1].label = this.$t('exportFile.brandHealthByWeek')
    },
    checkboxSource : function () {
      this.optionalArticle[0].label = this.$t('exportFile.postFb')
      this.optionalArticle[1].label = this.$t('exportFile.commentFb')
      this.optionalArticle[2].label = this.$t('exportFile.news')
    },
    exportFile: function(){
      const result = this.valueSelected.map(el => el.value);
      const restultArticle = this.valueSelectedArticle.map(el => el.value);
      if(this.valueOption === null){
        return this.$vs.notify({
          text:this.$t('exportFile.textReport'),
          icon:'icon-alert',
          iconPack:'feahter',
          color:'danger'
        })
      }
      this.$vs.loading();
      if(this.dateRange){
        const endDate = new Date(this.dateRange.endDate.setHours(23,59,59));
        const startDate = new Date(this.dateRange.startDate.setHours(0,0,0))
        const payload ={
          from:startDate,
          to: endDate,
          topics: result,
          beanTypes: restultArticle
      }
      if(this.valueOption == 0){
        this.$report.post(`user-data/export-file`,payload).then((response) =>{
          this.$vs.loading.close();
          if (response || !response.data) return this.$vs.notify({
            text: this.$t('createReportError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
          return this.$vs.notify({
            text:this.$t('exportFile.textSuccess'),
            icon:'icon-alert',
            iconPack:'feahter',
            color:'color'
          })
      })
      .catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
      }
      if(this.valueOption == 1){
        this.$report.post(`user-data/export-file-powerpoint`,payload).then((response) =>{
          this.$vs.loading.close();
          if (response || !response.data) return this.$vs.notify({
            text: this.$t('createReportError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
          return this.$vs.notify({
            text:this.$t('exportFile.textSuccess'),
            icon:'icon-alert',
            iconPack:'feahter',
            color:'color'
          })
      })
      .catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
      }
      if(this.valueOption == 2){
        this.$report.post(`user-data/export-file-vnPost`,payload).then((response) =>{
          this.$vs.loading.close();
          if (response || !response.data) return this.$vs.notify({
            text: this.$t('createReportError'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
          this.$vs.loading.close();
          return this.$vs.notify({
            text:'Xuất báo cáo thành công',
            icon:'icon-alert',
            iconPack:'feahter',
            color:'color'
          })
      })
      .catch((err) =>{
        this.$vs.loading.close();
        return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
      }
      }
    },
    saveByteArray:function(reportName, byte) {
    var blob = new Blob([byte], {type: "application/xml"});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
    }
  },
  async created(){
    this.initScreen();
    this.$eventBus.$on('i18n', () => {
      this.initScreen();
    });
    let userInfo = JSON.parse(localStorage.userInfo);
    if (userInfo.email.includes("vnpost")) {
      this.optionalTime.push({label:'Sức khoẻ thương hiệu VnPost', value:2})
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss";
.vue-daterange-picker .ranges {
    float: right;
    border-left: 1px solid #ddd;
  }
  .daterangepicker {
    border-left: none !important;
  }
.export-file{
  position: absolute;
  right: 2rem;
}
.reportrange-text{
  border-radius: 10px;
  height: 37px;
  line-height: 27px;
}
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.minus-top{
  margin-top: -24px;
}
.selected-topic .vs__selected{
  color: #fff;
  background-color: #5C6BC0;
}
.selected-topic .v-select .vs__dropdown-toggle .vs__deselect svg{
  stroke: #fff;
  opacity: 1;
}
</style>
